export type AuthMode = 'token' | 'cookie' | 'none'
/**
 * token  — обычный режим: прикрепляем Bearer, API-запросы без cookies,
 *           а спец-эндпоинты (sign-in/2FA/refresh) — с cookies.
 * cookie — полностью cookie-сессия: Bearer не ставим, все запросы с withCredentials=true.
 * none   — режим без авторизации (страницы /auth): ничего не прикрепляем, cookies не шлём.
 */
let mode: AuthMode = 'token'

export function getAuthMode() { return mode }
export function setAuthMode(next: AuthMode) { mode = next }

export function useTokens() { return mode === 'token' }
export function useCookiesEverywhere() { return mode === 'cookie' }
export function isAuthDisabled() { return mode === 'none' }

/** Нужны ли cookies для именно auth-эндпоинтов (sign-in / 2FA / refresh) */
export function withCredentialsForAuthEndpoints() {
    return true
}

/** Нужны ли cookies для обычных API-запросов */
export function withCredentialsForApiRequests() {
    return mode === 'cookie'
}